import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ShellComponent } from './shell/shell.component';
import { HeaderComponent } from './shell/header/header.component';
import { MainComponent } from './shell/main/main.component';
import { FooterComponent } from './shell/footer/footer.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ToolsModule } from '../tools/tools.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MainWrapComponent } from './shell/main-wrap/main-wrap.component';
import { TranslateModule } from '@ngx-translate/core';
import { PrivatePolicyTemplateSheetModule } from 'src/app/tools/templatesheets/private-policy-template-sheet/private-policy-template-sheet.module';
import { TerminsAndConditionsTemplateSheetModule } from 'src/app/tools/templatesheets/termins-and-conditions-template-sheet/termins-and-conditions-template-sheet.module';

@NgModule({
  declarations: [ShellComponent, HeaderComponent, MainComponent, FooterComponent, NotFoundComponent, MainWrapComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    ToolsModule,
    TranslateModule,
    PrivatePolicyTemplateSheetModule,
    TerminsAndConditionsTemplateSheetModule
  ],
  exports: [ShellComponent]
})
export class CoreModule {}
